<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <!-- <Toast style="margin-top: 35px" /> -->
    <form>
      <div class="p-grid justify-content-end">
        <div class="p-col">
          <Button
            class="p-button p-component p-button-success addNewBtn btn-btm-0"
            @click.prevent="displayBasic=true"
            icon="pi pi-plus"
            label="NEW"
          />
        </div>
      </div>
      <Dialog
        header="Monthly Target"
        :visible.sync="displayBasic"
        :style="{width: '30vw'}"
        :modal="false"
        :closable="true"
        @hide="closeDialog"
        :contentStyle="{'overflow': 'visible'}"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="head">Month<span style="color: red">*</span></label>
            <Dropdown
              v-model="month"
              optionLabel="key"
              placeholder="Select One"
              :filter="true"
              :options="monthList"
              :showClear="true"
              id="account"
            />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="openingBalance">Target Amount </label>
            <InputText
              id="openingBalance"
              @keypress="isNumber($event)"
              v-model.number="targetAmount"
            />
          </div>
        </div>
        <template #footer>
          <Button
            class="p-button-raised"
            @click.prevent="addMonthlyTarget"
            :label="editing?'Update':'Add'"
          />
          <Button
            class="p-button-raised p-button-info"
            @click.prevent="saveAndNewMonthlyTarget"
            v-if="!editing"
            label="Add & New"
          />
          <Button
            @click.prevent="closeDialog"
            class="p-button-raised p-button-danger"
            label="Cancel"
            >Cancel</Button
          >
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
export default {
  name: 'MonthlyTargetDialog',
  data() {
    return {
      targetAmount: 0,
      displayBasic: false,
      editing: false,
      id: null,
      loading: false,
      month: null,
      monthList: [
          { key: 'Baisakh', value: 1 },
          { key: 'Jestha', value: 2 },
          { key: 'Ashadh', value: 3 },
          { key: 'Shrawan', value: 4 },
          { key: 'Bhadra', value: 5 },
          { key: 'Ashwin', value: 6 },
          { key: 'Kartik', value: 7 },
          { key: 'Mangsir', value: 8 },
          { key: 'Poush', value: 9 },
          { key: 'Magh', value: 10 },
          { key: 'Falgun', value: 11 },
          { key: 'Chaitra', value: 12 }
      ]
    }
  },
  methods: {
    async addMonthlyTarget() {
      if (this.month === undefined || this.month === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select Month!', life: 3000})
        return
      }
      if (this.targetAmount <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Target amount must be greater than zero!', life: 3000})
        return
      }
      let monthlyTarget = {
        month_name: this.month.key,
        month_id: this.month.value,
        target_amount: this.targetAmount,
        id: this.id
      }
      try {
        this.loading = true
        const action = this.editing ? 'updateMonthlyTarget' : 'createMonthlyTarget'
        const response = await this.$store.dispatch(action, monthlyTarget)
        this.loading = false
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: this.editing ? 'Target updated successfully' : 'Target added successfully', life: 3000})
          this.$emit('refresh-list')
          this.closeDialog()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
          return
        }
      } catch (error) {
        this.loading = false
        this.$toast.add({severity: 'error', summary: '', detail: 'Operation failed: ' + (error.message || 'Unknown error'), life: 5000})
      }
    },
    async saveAndNewMonthlyTarget() {
      let response = ''
      if (this.month === undefined || this.month === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select Month!', life: 10000})
        return
      }
      let monthlyTarget = {
        month_name: this.month.key,
        month_id: this.month.value,
        target_amount: this.targetAmount,
        id: this.id
      }
      try {
        this.loading = !this.loading
        response = await this.$store.dispatch('createMonthlyTarget', monthlyTarget)
        this.loading = false
        if (response.data.status === 'SUCCESS') {
          this.$emit('refresh-list')
          this.reset()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
          return
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
        this.loading = false
        return
      }
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    editTarget(target) {
      this.editing = true
      this.id = target.id
      this.targetAmount = target.target_amount
      this.month = this.monthList.find(m => m.value === target.month_id)
      this.displayBasic = true
    },
    closeDialog() {
      this.displayBasic = false
      this.reset()
    },
    reset() {
      this.targetAmount = 0
      this.month = null
      this.editing = false
    }
  },
  components: {
    Dropdown,
    Dialog,
    RadioButton,
    InputText,
    Button,
    Checkbox
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// monthlyTargetDialog.vue?561e62bf